// @ts-nocheck
import * as React from "react";

const QuickOrderFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 -960 960 960">
            <path d="M733.42-208.78v-108.14h-30.15v120.01l80.77 80.14L805.27-138l-71.85-70.78ZM467.88-790 224.12-648.88 480-500.46l256.27-148.42L492.5-790q-6.15-3.85-12.31-3.85-6.15 0-12.31 3.85ZM165.54-337.35v-285.69q0-16.17 7.92-30.42t23.04-23.04l252.92-145.42q7.46-4.62 15.02-6.35Q472-830 480.04-830t15.81 1.73q7.77 1.73 15.11 6.35L763.88-676.5q14.74 8.79 22.66 23.04t7.92 30.42v148.58h-36.92v-144.5L479.5-458.31 202.46-619.08v281.39q0 6.15 3.08 11.54 3.08 5.38 9.23 9.23l255.38 148.54v42L196.5-284q-15.12-8.79-23.04-22.65-7.92-13.87-7.92-30.7ZM718.2-50q-65.05 0-110.39-45.3-45.35-45.31-45.35-110.35 0-65.04 45.31-110.39 45.3-45.34 110.34-45.34t110.39 45.3q45.35 45.31 45.35 110.35 0 65.04-45.31 110.38Q783.24-50 718.2-50ZM480-480.42Z" />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(QuickOrderFill);
